import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {Card, FormControl} from "@mui/material";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import Grid from "@mui/material/Grid";
import MDButton from "../../components/MDButton";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import PageLoading from "../common/PageLoading";
import {getCompanyPreferences, saveCompanyPreferences} from "../common/api/WebApi";
import {Controller, useForm} from "react-hook-form";
import Switch from "@mui/material/Switch";
import {CompanyContext} from "../../lib/CompanyContext";
import TextField from "@mui/material/TextField";


export default function CompanyPreferences(props) {

  const [isNew, setIsNew] = useState(true);
  const [loading, setLoading] = useState(true);
  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [preferencesSaving, setPreferencesSaving] = useState(false);
  const [preferencesChanged, setPreferencesChanged] = useState(false);
  const [saving, setSaving] = useState(false);

  const [preferences, setPreferences] = useState();

  const PREFERENCE_TYPES = {
    TEXT: 1,
    NUMBER: 2,
    DECIMAL: 3,
    BOOLEAN: 4,
    SELECT: 5
  }

  const getPreferences = () => {
    getCompanyPreferences().then((resp) => {
      setPreferences(resp);
      setLoading(false);
      setSaving(false);
    });
  }

  const normalizeValue = (pref) => {
    if (pref.type === PREFERENCE_TYPES.BOOLEAN) {
      return pref.value === true || pref.value === "true";
    }
    return pref.value ?? pref.defaultValue ?? "";
  };

  const buildDefaultValues = (preferences) => {
    return preferences.reduce((acc, pref) => {
      acc[pref.key] = normalizeValue(pref);
      return acc;
    }, {});
  };

  useEffect(() => {
    getPreferences();
  }, []);

  const PreferencesForm = ({preferences}) => {
    const {register, setValue, control, formState: {isDirty}, handleSubmit} = useForm({
      defaultValues: buildDefaultValues(preferences)
    });

    const onSubmit = (data) => {
      let _prefs = [...preferences];
      const updatedPreferences = _prefs.map((pref) => ({
        ...pref,
        value: data[pref.key] // overwrite only the value
      }));
      setSaving(true);
      saveCompanyPreferences(updatedPreferences).then((resp) => {
        let c = {...companyContext};
        c.refreshContext = true;
        setCompanyContext(c);
        getPreferences();
      });
    };

    let groupName = null;

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <table className={'table table-striped table-hover'}>
          <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              Default
            </th>
            <th>
              Value
            </th>
          </tr>
          </thead>
          <tbody>
          {!saving && preferences.sort((a, b) => a.sortOrder - b.sortOrder)?.map((pref) => {

            const showGroupHeader = pref.groupName !== groupName;
            groupName = pref.groupName;

            return (
              <React.Fragment key={pref.id}>
                {showGroupHeader && (
                  <tr className="group-header">
                    <td colSpan="3">
                      <strong>{pref.groupName}</strong>
                    </td>
                  </tr>
                )}
                <tr>
                  <td>
                    {pref.name}
                  </td>
                  <td>
                    {pref.defaultValue}
                  </td>
                  <td>
                    {pref.type.id === PREFERENCE_TYPES.TEXT && <>
                      <FormControl sx={{ width: 'auto' }}>
                        <Controller
                          name={pref.key}
                          control={control}
                          defaultValue={pref.value ?? pref.defaultValue}
                          render={({ field }) => (
                            <TextField
                              {...field} className={'form-control'} style={{
                                background:'#fff'
                            }}
                              value={field.value ?? pref.defaultValue}
                              onChange={(e) => field.onChange(e.target.value)}
                            />
                          )}
                        />
                      </FormControl>
                    </>}
                    {pref.type.id === PREFERENCE_TYPES.BOOLEAN && <>
                      <FormControl sx={{
                        width: 'auto'
                      }}>
                        <Controller
                          name={pref.key}
                          control={control}
                          defaultValue={pref.value ?? "false"}
                          render={({field}) => (
                            <Switch
                              {...field}
                              checked={field.value === "true"}
                              onChange={(e) =>
                                field.onChange(e.target.checked ? "true" : "false")
                              }
                            />
                          )}
                        />
                      </FormControl>
                    </>
                    }

                    {pref.type.id === PREFERENCE_TYPES.SELECT && <>
                      <FormControl sx={{
                        width: 'auto'
                      }}>
                        <select {...register(pref.key)} className={'form-select'}>
                          {pref.options?.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.name}
                            </option>
                          ))}
                        </select>
                      </FormControl>
                    </>
                    }
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
          </tbody>
        </table>

        <MDButton type="submit" disabled={!isDirty || preferencesSaving}
                  color="info"
                  size="small"
                  className="pull-right"
                  variant="contained">
          {saving ? 'Saving Preferences...' : 'Save Preferences'}
        </MDButton>
      </form>
    );
  };

  return (
    <>
      <DashboardLayout>
        <Meta pageTitle={'Company Preferences'}/>
        <ContextSearchNavbar title="Company Preferences"/>

        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <MDBox pb={3}>
                <MDBox mb={3}>
                  <Card>
                    <MDBox p={3} lineHeight={1}>

                      <h5 fontWeight="regular">
                        Company Preferences
                      </h5>

                      {preferences?.length > 0 &&
                        <PreferencesForm preferences={preferences}/>
                      }

                    </MDBox>

                  </Card>
                </MDBox>

                {loading && <PageLoading/>}

              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <Footer mt={5}/>
      </DashboardLayout>
    </>
  );
}